import { ServiceResponse } from "./ServiceResponse";

export class SendEmailResponse extends ServiceResponse {
}
